import React, { useState, useEffect } from 'react';

const AmenityModal = ({ isOpen, setIsOpen ,initialValue='', onSubmit }) => {
        const [inputValue, setInputValue] = useState('');

           useEffect(() => {
        setInputValue(initialValue);
    }, [initialValue]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!inputValue.trim()) return;
        onSubmit(inputValue.trim());
        setInputValue('');
    };


    if (!isOpen) return null;

    return (
        <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
            <div
                className="custom-modal-content"
                onClick={(e) => e.stopPropagation()} // Prevent closing on content click
            >
                <h2 className="oms-modal-title">Amenity</h2>
                <form className="oms-modal-form"  onSubmit={handleSubmit}>
                    <div className="oms-form-group">
                        <label htmlFor="featureName" className="oms-form-label">
                            Amenity Name
                        </label>
                        <input
                            type="text"
                             id="amenityName"
                            placeholder="Enter amenity name"
                            value={inputValue}
                            onChange={(e) => setInputValue(e.target.value)}
                        />
                    </div>
                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>
                            Cancel
                        </button>
                        <button type="submit">Submit</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AmenityModal;
